export const tutorialResourceType = "tutorial" as const;

export const completeTutorialStepPath = (
  companyId: string,
  tutorialId: string
) => {
  return `/companies/${companyId}/tutorial_progress/${tutorialId}/complete_step`;
};
